module.exports = __webpack_public_path__ + "static/media/korean-flag.666bc220.svg";